const MODULE_NAME = 'ConflictsModule';

// eslint-disable-next-line import/prefer-default-export
export const GET_ALL_CONFLICTS = `${MODULE_NAME}/GET_ALL_CONFLICTS`;
